import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService, fromMinutesToMilliseconds } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class PageConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getPageEndpoint(): string {
		return this.configService.get((x) => x.core.page.endpoints!.page, "v1/pagecontent");
	}

	getPagesCacheMaxAge(): number {
		return this.configService.get((x) => x.core.page.cacheMaxAge!.page, fromMinutesToMilliseconds(60));
	}
}
